/**
 * Application Entry Point
 * Renders the main App component with proper React 18 setup and configuration management
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ConfigProvider } from './components/ConfigProvider';
import ConfigLoader from './components/ConfigLoader';
import '@aws-amplify/ui-react/styles.css';

// Get the root element
const container = document.getElementById('root');
const root = createRoot(container);

// Render the application with configuration management
root.render(
  <React.StrictMode>
    <ConfigProvider>
      <ConfigLoader>
        <App />
      </ConfigLoader>
    </ConfigProvider>
  </React.StrictMode>
);

// Web Vitals for performance monitoring (optional)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
import('./reportWebVitals').then(({ default: reportWebVitals }) => {
  reportWebVitals();
}).catch(() => {
  // Optional web vitals import failed - not critical
});